import {
  STATION_LOADING,
  STATION_ERROR,
  STATION_LIST,
  STATION_FILTERS,
} from "actions/chargers/station/constants";

const initialState = {
  loading: false,
  errors: [],
  filters: [],
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case STATION_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case STATION_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case STATION_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case STATION_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chargers/chargerStationReducer.js